import axios from '@/utils/axios'

import { defineStore } from 'pinia'
import { getSavedState, saveState } from '@/utils/helper'
import { useAuthStore } from './auth'
import { useNotificationStore } from './notification'

export const useFundingSourceStore = defineStore('fundingSource', {
  state: () => ({
    fundingSources: getSavedState('fundingSource.All') || [],
    created: false
  }),
  getters: {
    getAllFundingSources(state) {
      return state.fundingSources
    },
    isFundingSourceCreated(state) {
      return state.created
    }
  },
  actions: {
    setAllFundingSources(newValue) {
      this.fundingSources = newValue
      saveState('fundingSource.All', this.fundingSources)
    },
    fetchAllFundingSources() {
      const authStore = useAuthStore()

      this.fundingSources = []
      const timestamp = Math.round(new Date().getTime() / 1000 / 5) * 5
      return axios
        .get('/account/funding', {
          params: {
            jwt: authStore.getToken,
            timestamp
          }
        })
        .then((Response) => {
          this.setAllFundingSources(Response.data)
          return Response.data
        })
        .catch((Error) => {
          const notification = useNotificationStore()
          notification.getNotificationError(Error)
          return Promise.reject(Error)
        })
    },
    addFundingSource({ stripe_token, recaptchaToken = '', token, consumableRecaptchaBypassToken }) {
      const authStore = useAuthStore()
      const jwToken = authStore.getToken || token

      this.created = false

      const formData = new FormData()
      formData.append('jwt', jwToken)
      formData.append('stripe_token', stripe_token)

      if (recaptchaToken) {
        formData.append('recaptcha_token', recaptchaToken)
      }

      if (consumableRecaptchaBypassToken) {
        formData.append('consumable_recaptcha_bypass_token', consumableRecaptchaBypassToken)
      }

      return axios
        .post('/account/funding', formData, {
          headers: {
            'X-Harness-JWT': jwToken
          }
        })
        .then((Response) => {
          this.created = true
          return Response.data
        })
        .catch((Error) => {
          const notification = useNotificationStore()
          notification.getNotificationError(Error)
          return Promise.reject(Error)
        })
    },
    deleteFundingSource(fundingSourceId) {
      const authStore = useAuthStore()

      return axios
        .delete(`/account/funding/${fundingSourceId}`, {
          params: {
            jwt: authStore.getToken
          }
        })
        .then((Response) => {
          return Response.data
        })
        .catch((Error) => {
          const notification = useNotificationStore()
          notification.getNotificationError(Error)
          return Promise.reject(Error)
        })
    }
  }
})
